import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createDoBoxDropdownSlice } from './actions';
import { DoBoxDropdownStore } from './types';
import { ZustandStores } from '../utils';
import { createIndexedDBStorage } from '../utils/indexedDBAdapter';

export const useDoBoxDropdownStore = create<DoBoxDropdownStore>()(
  persist(
    (set, get, store) => ({
      ...createDoBoxDropdownSlice(set, get, store),
    }),
    {
      name: ZustandStores.DOBOX_DROPDOWN_STATES,
      storage: createJSONStorage(() => createIndexedDBStorage()),
    },
  ),
);
